/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountNameFilters } from '../models/AccountNameFilters';
import { AccountStatusFilters } from '../models/AccountStatusFilters';
import { CloudProviderFilters } from '../models/CloudProviderFilters';
import { FreeTextFilters } from '../models/FreeTextFilters';
import { IdFilters } from '../models/IdFilters';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters';

/**
* Filter conditions. If omitted, no filtering is applied. 
*/
export class RestoreAccountsFilterConditions {
  'id'?: IdFilters;
  'providerAccountId'?: ProviderAccountIdFilters;
  'accountStatus'?: AccountStatusFilters;
  'cloudProvider'?: CloudProviderFilters;
  'accountName'?: AccountNameFilters;
  'freeText'?: FreeTextFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "ProviderAccountIdFilters",
      "format": ""
    },
    {
      "name": "accountStatus",
      "baseName": "accountStatus",
      "type": "AccountStatusFilters",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "CloudProviderFilters",
      "format": ""
    },
    {
      "name": "accountName",
      "baseName": "accountName",
      "type": "AccountNameFilters",
      "format": ""
    },
    {
      "name": "freeText",
      "baseName": "freeText",
      "type": "FreeTextFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAccountsFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

